import { render } from "./addressfield.vue?vue&type=template&id=6e671092&scoped=true"
import script from "./addressfield.vue?vue&type=script&lang=js"
export * from "./addressfield.vue?vue&type=script&lang=js"

import "./addressfield.vue?vue&type=style&index=0&id=6e671092&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e671092"]])

export default __exports__